import Vue from 'vue';

const ALERT_TIMEOUT_MS = 2500;

class Alert extends Vue {

    displaying = false;
    message: string | null = null;
    error = false;
    timeout: ReturnType<typeof setTimeout> | null = null;


    private resetTimeout() {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(() => {
            this.timeout = null;
            this.displaying = false;
            this.emitChange();
        }, ALERT_TIMEOUT_MS);
    }

    private emitChange() {
        this.$emit('change', {
            data: {
                message: this.message,
                displaying: this.displaying,
                error: this.error,
            },
        });
    }

    showAlert(message: string, error = false) {
        this.message = message;
        this.error = error;
        this.displaying = true;
        this.resetTimeout();
        this.emitChange();
    }

    showMessage(message: string) {
        this.showAlert(message, false);
    }

    showError(message: string | Error) {
        this.showAlert(message.toString(), true);
    }
}


export default new Alert;
